// src/services/deviceApi.js
import { apiClient } from "../utils/apiClient";

export const testConnection = async (payload) => {
    return await apiClient("Device/test-connection", { method: "POST", body: payload });
};

export const testConnectionById = async (id, password) => {
    const body = password ? { password } : undefined;
    return await apiClient(`Device/${id}/test-connection`, { method: "POST", body });
};

export const testConnectionCmd = async (id) => {
    return await testConnectionById(id);
};

export const getConnectionCmdStatus = async (id) => {
    return await apiClient(`Device/${id}/test-connection/status`, { method: "GET" });
};

export const openDoorById = async (id, passwordOrOpts = null, doorNo = 1, durationSeconds = null) => {
    const body = {};
    if (passwordOrOpts && typeof passwordOrOpts === "object") {
        if (passwordOrOpts.password) body.password = passwordOrOpts.password;
        body.doorNo = passwordOrOpts.doorNo ?? 1;
        if (passwordOrOpts.durationSeconds != null) body.durationSeconds = passwordOrOpts.durationSeconds;
    } else {
        if (passwordOrOpts) body.password = passwordOrOpts;
        if (doorNo != null) body.doorNo = doorNo;
        if (durationSeconds != null) body.durationSeconds = durationSeconds;
    }
    return await apiClient(`Device/${id}/open-door`, { method: "POST", body });
};

export const openDoor = async (id, password, doorNo = 1, durationSeconds = null) => {
    return await openDoorById(id, password, doorNo, durationSeconds);
};

export const applyDoorSettings = async (id, durationSeconds) => {
    const body = {};
    if (durationSeconds != null) body.durationSeconds = durationSeconds;
    return await apiClient(`Device/${id}/apply-door-settings`, { method: "POST", body });
};

export const fetchDeviceInfo = async (payload) => {
    return await apiClient("Device/fetch-device-info", { method: "POST", body: payload });
};

export const getReaderSettings = async (deviceId, params = {}) => {
    const { username, password, useHttps, port, verifyCertificate, protocol } = params;
    const qs = new URLSearchParams();
    if (username) qs.append("username", username);
    if (password) qs.append("password", password);
    if (useHttps !== undefined) qs.append("useHttps", useHttps ? "true" : "false");
    if (port !== undefined && port !== null) qs.append("port", String(port));
    if (verifyCertificate !== undefined) qs.append("verifyCertificate", verifyCertificate ? "true" : "false");
    if (protocol) qs.append("protocol", protocol);

    const endpoint = qs.toString()
        ? `Device/${deviceId}/reader-settings?${qs.toString()}`
        : `Device/${deviceId}/reader-settings`;

    return await apiClient(endpoint, { method: "GET" });
};

export const setReaderSettings = async (deviceId, dto) => {
    return await apiClient(`Device/${deviceId}/reader-settings`, { method: "PUT", body: dto });
};

export const updateReaderSettings = setReaderSettings;

export const getAllDevices = async () => {
    return await apiClient("Device", { method: "GET" });
};

export const list = getAllDevices;

export const listGatewaySources = async (brand) => {
    const qs = brand ? `?brand=${encodeURIComponent(brand)}` : "";
    return await apiClient(`Device/gateway-sources${qs}`, { method: "GET" });
};

export const getById = async (id) => {
    return await apiClient(`Device/${id}`, { method: "GET" });
};

export const createDevice = async (deviceData) => {
    return await apiClient("Device", { method: "POST", body: deviceData });
};

export const updateDevice = async (id, deviceData) => {
    return await apiClient(`Device/${id}`, { method: "PUT", body: { ...deviceData, id } });
};

export const deactivateDevice = async (id) => {
    return await apiClient(`Device/deactivate/${id}`, { method: "PUT" });
};

export const getPanels = async () => {
    return await apiClient("Device/panels", { method: "GET" });
};

export const getPanelById = async (id) => {
    return await apiClient(`Device/panels/${id}`, { method: "GET" });
};

export const getPanel = getPanelById;

export const createPanel = async (panelData) => {
    return await apiClient("Device/panels", { method: "POST", body: panelData });
};

export const updatePanel = async (id, panelData) => {
    return await apiClient(`Device/panels/${id}`, { method: "PUT", body: panelData });
};

export const deviceApi = {
    testConnection,
    testConnectionById,
    testConnectionCmd,
    getConnectionCmdStatus,
    openDoorById,
    openDoor,
    applyDoorSettings,
    fetchDeviceInfo,
    getReaderSettings,
    setReaderSettings,
    updateReaderSettings,
    getAllDevices,
    list,
    listGatewaySources,
    getById,
    createDevice,
    updateDevice,
    deactivateDevice,
    getPanels,
    getPanelById,
    getPanel,
    createPanel,
    updatePanel,
};

export default deviceApi;
